import { render, staticRenderFns } from "./info-page.vue?vue&type=template&id=5431461a&scoped=true&"
import script from "./info-page.vue?vue&type=script&lang=js&"
export * from "./info-page.vue?vue&type=script&lang=js&"
import style0 from "./info-page.vue?vue&type=style&index=0&id=5431461a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.9.7_eeqz4xtr3chsfpwu4zsrvzqhvy/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5431461a",
  null
  
)

export default component.exports